import { useEffect, useState } from 'react'
import { useRef } from 'react'

export default function useDimensionObserver(
    props?: { onResize?: (width: number, height: number) => void } | undefined
) {
    const nodeRef = useRef<HTMLDivElement>(null)

    const [width, setWidth] = useState(0)
    const [height, setHeight] = useState(0)

    useEffect(() => {
        if (!nodeRef.current) {
            return
        }

        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.target === nodeRef.current) {
                    setWidth(entry.contentRect.width)
                    setHeight(entry.contentRect.height)

                    if (props?.onResize) {
                        props.onResize(entry.contentRect.width, entry.contentRect.height)
                    }
                }
            }
        })

        resizeObserver.observe(nodeRef.current)

        return () => resizeObserver.disconnect()
    }, [props?.onResize, nodeRef.current])

    return { width, height, nodeRef }
}
